let qvthumbnails;
$(document).ready(() => {
  $('#siteloader').fadeOut();
  $('#spin-wrapper').fadeOut();

  // fixed header
  (function ($) {
    let stickyTopDistance = null;
    let stickyTopMargin = null;
    let isMobile = null;
    let isSticky = null;

    function mediaSize() {
      if (window.matchMedia('(min-width: 992px)').matches) {
        isMobile = false;
        stickyTopDistance = $('.nav-header').outerHeight(true);
        stickyTopMargin = $('#header .site-header-inner').outerHeight(true);
      } else {
        isMobile = true;
        stickyTopDistance = $('.nav-header').outerHeight(true) || 0;
        stickyTopMargin = $('.site-header-mobile').outerHeight(true);
      }
    }
    $(window).on('scroll', () => {
      if ($(window).scrollTop() > stickyTopDistance) {
        if (!isSticky) {
          if (isMobile) {
            $('.site-header-mobile').addClass('fixed-header');
          } else {
            $('.header-top').addClass('fixed-header');
          }
          $('#header .nav-header').css('margin-bottom', stickyTopMargin);
          isSticky = true;
        }
      } else {
        if (isSticky) {
          $('.site-header-mobile').removeClass('fixed-header');
          $('.header-top').removeClass('fixed-header');
          $('#header .nav-header').css('margin-bottom', '');
          isSticky = false;
        }
      }
    });
    mediaSize();
    window.addEventListener('resize', mediaSize, false);
  })(jQuery);

  $("#SortTags").on("click", "a", function (e) {

    if ($(this).hasClass("selected")) {
      const tagName = $(this).data("tagname");
      var url = window.location.href;
      const tagStart = url.indexOf(tagName);
      const tagEnd = tagStart + tagName.length;

      e.preventDefault();
      if (url.charAt(tagStart - 1) == "/") {
        var url = url.replace(tagName, '');
        url = url.replace("+", '');
        window.location = url;
      } else if (url.charAt(tagEnd + 1) == "") {
        var url = url.replace(tagName, '');
        url = url.substring(0, (url.length - 1));
        window.location = url;
      } else {
        const url1 = url.substring(0, (tagStart));
        const url2 = url.substring((tagEnd + 1));
        var url = url1 + url2;
        window.location = url;
      }
    }
  });

  $('#product-thumbnails-carousel').owlCarousel({
    nav: true, // Show next and prev buttons
    navText: [
      '<i class=\'material-icons\'></i>',
      '<i class=\'material-icons\'></i>',
    ],
    dots: false,
    loop: false,
    margin: 15,
    rewind: true,
    responsive: {
      0: {
        items: 3,
      },
      544: {
        items: 4,
      },
      768: {
        items: 3,
      },
      992: {
        items: 3,
      },
      1200: {
        items: 4,
      },
    },
  });

  qvthumbnails = $('#qv-thumbnails').owlCarousel({
    nav: true,
    loop: false,
    navText: [
      '<i class=\'material-icons\'></i>',
      '<i class=\'material-icons\'></i>',
    ],
    responsive: {
      0: {
        items: 3,
      },
      544: {
        items: 5,
      },
      768: {
        items: 4,
      },
      992: {
        items: 4,
      },
      1200: {
        items: 5,
      },
    },
  });

  const cartUpdateStates = new Map();

  function getCartUpdateState(form) {
    let state = cartUpdateStates.get(form);
    if (!state) {
      state = { timer: null, submitting: false, unlockTimer: null };
      cartUpdateStates.set(form, state);
    }
    return state;
  }

  function clearScheduledCartUpdate(form) {
    const state = cartUpdateStates.get(form);
    if (state && state.timer) {
      window.clearTimeout(state.timer);
      state.timer = null;
    }
  }

  function clearAllScheduledCartUpdates() {
    cartUpdateStates.forEach((state) => {
      if (state.timer) window.clearTimeout(state.timer);
      if (state.unlockTimer) window.clearTimeout(state.unlockTimer);
    });
    cartUpdateStates.clear();
  }

  function scheduleCartUpdate(input, delay) {
    const form = input && input.closest('form.cart');
    const updateButton = form && form.querySelector('.update-qty');
    const value = input && input.value.trim();
    const quantity = value === '' ? NaN : Number(value);

    if (!form || !updateButton) return;

    const state = getCartUpdateState(form);
    const minimum = input.min === '' ? 0 : Number(input.min);

    if (!Number.isInteger(quantity) || quantity < minimum) {
      clearScheduledCartUpdate(form);
      return;
    }

    if (state.submitting) return;

    clearScheduledCartUpdate(form);
    state.timer = window.setTimeout(() => {
      state.timer = null;
      if (state.submitting || !document.documentElement.contains(form)) return;

      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(updateButton);
      } else {
        updateButton.click();
      }
    }, delay);
  }

  $(document).on('input', '.template-cart input.update-cart', function () {
    scheduleCartUpdate(this, 800);
  });

  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!form.matches('.template-cart form.cart')) return;

    const state = getCartUpdateState(form);
    clearScheduledCartUpdate(form);

    if (state.submitting) {
      event.preventDefault();
      return;
    }

    state.submitting = true;
    state.unlockTimer = window.setTimeout(() => {
      state.submitting = false;
      state.unlockTimer = null;
    }, 8000);

    window.setTimeout(() => {
      if (!event.defaultPrevented) return;
      state.submitting = false;
      if (state.unlockTimer) window.clearTimeout(state.unlockTimer);
      state.unlockTimer = null;
    }, 0);
  }, true);

  window.addEventListener('pagehide', clearAllScheduledCartUpdates);
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) clearAllScheduledCartUpdates();
  });

  // slide to top
  $(window).scroll(function () {
    if ($(this).scrollTop() > 500) {
      $('#slidetop').fadeIn(500);
    } else {
      $('#slidetop').fadeOut(500);
    }
  });
  $('#slidetop').click((e) => {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: 0,
    }, 800);
  });

  //COLLECTION GRID-LIST JAVASCRIPT START
  $(document).on("click", ".collectiongrid-layout", function () {
    var id = $(this).data("id");
    setTheCookie("collectiongrid-layout", id, 14);
    setGridLayout();
  });
  setGridLayout();
  //COLLECTION GRID-LIST JAVASCRIPT END

  // quantity selector quickview-modal and product-page
  $(document).on("click", ".product-form__item--quantity .button", function () {
    const n = $(".product-form__item--quantity .quantity").val();
    if ($(this).text() == "+") {
      var r = parseInt(n) + 1;
    } else {
      if (n == 1) { return; }
      var r = parseInt(n) - 1;
    }
    $('input.quantity').val(r);
    $(".update-qty").trigger('click');
  });

  // quantity selector for cart-page
  $(document).on("click", ".template-cart .cart-qty-btns .button", function (event) {
    event.preventDefault();

    const input = $(this).siblings(".quantity").get(0);
    const quantity = input ? parseInt(input.value, 10) : NaN;
    const form = input && input.closest('form.cart');
    const state = form && getCartUpdateState(form);

    if (!input || Number.isNaN(quantity) || (state && state.submitting)) return;
    if (!$(this).hasClass('qtyplus') && quantity <= 0) return;

    input.value = $(this).hasClass('qtyplus') ? quantity + 1 : Math.max(0, quantity - 1);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    scheduleCartUpdate(input, 450);
  });


  // for change grid to list view
  $(document).on('click', '.list-img', function (e) {
    if ($(this).hasClass('checked')) {

    } else {
      $('#list-img').addClass('checked');
      $('#grid-img').removeClass('checked');
      $('.products-display-collection .grid__item').each(function () {
        $(this).removeClass('small--one-half');
        $(this).removeClass('grid__item');
        $(this).removeClass(' medium-up--one-quarter');
        $(this).addClass('one-whole');
        $(this).addClass('list__item');
        initWishlistButtons();
      });
      $('.products-display-collection .grid-view-item__image-wrapper').each(function () {
        $(this).addClass('col-sm-4');
      });
      $('.products-display-collection .product-description').each(function () {
        $(this).addClass('col-sm-8');
      });

      $('#Collection').fadeOut(0);
      $('#Collection').fadeIn(500);
    }
  });
  // for change list to grid view
  $(document).on('click', '.grid-img', function (e) {
    if ($(this).hasClass('checked')) {

    } else {
      $('#list-img').removeClass('checked');
      $('#grid-img').addClass('checked');
      $('.products-display-collection .list__item').each(function () {
        $(this).addClass('small--one-half');
        $(this).addClass('grid__item');
        $(this).removeClass('one-whole');
        $(this).removeClass('list__item');
        initWishlistButtons();
      });
      $('.products-display-collection .grid-view-item__image-wrapper').each(function () {
        $(this).removeClass('col-sm-4');
      });
      $('.products-display-collection .product-description').each(function () {
        $(this).removeClass('col-sm-8');
      });

      $('#Collection').fadeOut(0);
      $('#Collection').fadeIn(500);
    }
  });

  // JS FOR LEFT COLUMN
  if ($('#left-column-category').length > 0) {
    $('#left-column-category').html($('#_desktop_top_menu').html());
    $('#left-column-category').find('.dropdown-inner').css('width', 'auto');
  }

  // to distinguish category tree id from the main menu.
  $('.category-tree').each(() => {
    function myFunction() {
      const str = document.getElementById("top-menu").innerHTML;
      const res = str.replace(/_n_/g, "_m_");
      document.getElementById("top-menu").innerHTML = res;
    }
    myFunction();
  });


  $(document).on("click", ".nm-addToCart.enable", function () {
    const variantID = $(this).parents(".add_to_cart_main").find('input[name="prduct-variant"]')
      .val();
    const qty = $(this).parents(".add_to_cart_main").find('input[name="product-quantity"]')
      .val();
    $(this).addClass('adding');
    productAddToCart(variantID, qty);
    if ($(".cart-display .cart-container").hasClass('in')) {
      $(".cart-display .cart-container").removeClass('in');
      $(".cart-display .cart-title").addClass('collapsed');
      $(".cart-display .cart-title").attr("aria-expanded", "false");
    }
  });

  $('#menu-icon').on('click', () => {
    $("#mobile_top_menu_wrapper").animate({
      width: "toggle",
    });
    $('.mobile-menu-overlay').toggleClass("active");
  });

  $('#top_menu_closer i').on('click', () => {
    $("#mobile_top_menu_wrapper").animate({
      width: "toggle",
    });
    $('.mobile-menu-overlay').toggleClass("active");
  });

  $('.mobile-menu-overlay').on('click', () => {
    $("#mobile_top_menu_wrapper").animate({
      width: "toggle",
    });
    $('.mobile-menu-overlay').toggleClass("active");
  });

  // JS FOR cart dropdown
  $(document).on("click", ".cart-container a.remove", function () {
    const variantID = $(this).data("variantid");
    productRemoveFormCart(variantID);

  });

  $(document).on("change", "#ProductSection-product-template select.single-option-selector", () => {
    adjustProductInventory();
  });

  $(document).on("change", "[data-dropdown-id='productSelect-dropdown']", function () {
    const productDropdown = $(this);
    const currentSelectedVariantId = productDropdown.val();
    const lastSelectedVariantId = productDropdown.attr('last');
    const productInput = $(`input[value="${lastSelectedVariantId}"]`);

    const productPriceContainer = $(productDropdown).parent().siblings('div.grid-view-item__meta').find('.product-price').first();
    const productPriceNormal = productPriceContainer.find('.product-price__price');
    const productPriceCompareAt = productPriceContainer.find('.product-price__compare-at-price');

    const productVariants = JSON.parse(productPriceContainer.attr('variants'));
    const selectedVariantData = productVariants[currentSelectedVariantId];

    productPriceNormal.text(Shopify.formatMoney(selectedVariantData.price, window.theme.moneyWithCurrencyFormat));

    if (selectedVariantData.compareAtPrice) {
      productPriceCompareAt.text(Shopify.formatMoney(selectedVariantData.compareAtPrice, window.theme.moneyWithCurrencyFormat));
      productPriceCompareAt.removeClass('hidden');
    } else {
      productPriceCompareAt.addClass('hidden');
    }

    productInput.val(currentSelectedVariantId);
    productInput.attr('value', currentSelectedVariantId);
    productDropdown.attr('last', currentSelectedVariantId);
  });

  adjustCartDropDown();
  adjustProductInventory();

  updateWishlistButtons();
  initWishlistButtons();

  function initWishlistButtons() {
    if (!window.VmaxWishlist) return false;
    window.VmaxWishlist.initialize();
    return true;
  }

  function updateWishlistButtons() {
    if (window.VmaxWishlist) window.VmaxWishlist.syncButtons();
  }

  // STOCK URGENCY START
  const stock = parseInt($("#variant-stock").html());
  const maxqty = parseInt($(".product-single-right .progress-content").data("quantity"));
  if (stock == '' || stock <= 0) { $(".product-single-right .progress-content").addClass('hide'); }
  switch (stock) { case 9: case 8: case 7: $("#progress-bar span").css("width", "70%"); break; case 6: $("#progress-bar span").css("width", "50%"); break; case 5: $("#progress-bar span").css("width", "40%"); break; case 4: $("#progress-bar span").css("width", "30%"); break; case 3: $("#progress-bar span").css("width", "20%"); break; case 2: $("#progress-bar span").css("width", "10%"); break; case 1: $("#progress-bar span").css("width", "5%"); break; default: $("#progress-bar span").css("width", "90%"); }
  // STOCK URGENCY END

});

function cloneToMobile() {
  $("*[id^='_desktop_']").each(function (index, element) {
    const target = $(`#${element.id.replace('_desktop_', '_mobile_')}`);
    target.html($(this).html());
  });
}

cloneToMobile();

function converToDesktop() {
  // interchange sections
  $(document).find('.normal-sidebar').append(`<div class="shopify-section" id="shopify-section-sidebar">${$(document).find('.responsive-sidebar .shopify-section').html()}</div>`);
  $(document).find('.responsive-sidebar').find('.shopify-section')
    .remove();
}

function productRemoveFormCart(variantID) {
  jQuery.ajax({
    type: "post",
    url: "/cart/change.js",
    data: `${"quantity=0" + "&id="}${variantID}`,
    dataType: "json",
    beforeSend() {

    },
    success(n) {
      adjustCartDropDown();
    },
    error(n, r) {
    },
  });
}
function adjustCartDropDown() {
  Shopify.getCart((e) => {
    const productList = $(".cart-container .product-list");
    productList.html('');
    const cartempty = $(".cart-container .cart__empty");
    const cartfooter = $(".cart-container .cart__footer");
    $('.cart__subtotal').html(Shopify.formatMoney(e.total_price, Shopify.money_format));
    $('.cart-qty').html(e.item_count);
    if (e.items.length > 0) {
      $.each(e.items, (index, value) => {
        const product = $("<div class='product'></div>");
        const productimg = $("<div class='product-img'></div>");
        const productdata = $("<div class='product-data'></div>");
        productimg.append(`<img loading="lazy" src='${value.image}' alt='${value.title}''>`);
        productdata.append(`<a href='${value.url}' class='product-title'>${value.title}</a>`);
        productdata.append(`<span class='product-price'>${value.quantity} x ${Shopify.formatMoney(value.discounted_price, Shopify.money_format)}</span>`);
        product.append(productimg);
        product.append(productdata);
        product.append(`<a class='remove' data-variantid=${value.variant_id}><i class='material-icons'>delete</i></a>`);
        productList.append(product);
      });
      cartfooter.removeClass('hide');
      productList.removeClass('hide');
      cartempty.addClass('hide');
      productList.slimScroll({
        height: e.items.length > 1 ? '262px' : '100%',
      });
    } else {
      cartempty.removeClass('hide');
      cartfooter.addClass('hide');
      productList.addClass('hide');
    }
  });
}

window.Shopify.adjustCartDropDown = adjustCartDropDown;

function adjustProductInventory() {
  const attr = $('#AddToCart-product-template').attr('disabled');

  if (typeof attr !== typeof undefined && attr !== false) {
    $('#inventory span.instock').hide();
    $('#inventory span.outstock').show();
  } else {
    $('#inventory span.instock').show();
    $('#inventory span.outstock').hide();
  }
}

/** ***************start animation script*******************/
jQuery(window).scroll(() => {
  hb_animated_contents();
});

function hb_animated_contents() {
  jQuery(".hb-animate-element:in-viewport").each(function (i) {
    const $this = jQuery(this);
    if (!$this.hasClass('hb-in-viewport')) {
      setTimeout(() => {
        $this.addClass('hb-in-viewport');
      }, 200 * i);
    }
  });
}

/** ***************end animation script*******************/
